import Base from "./Base";
import axios from "./axios_c";
import Order from "@system/config/order";
import ResponseMaker from "./OrderAPICall/responseMaker";
import orderByLineItemResponseMaker from "./OrderAPICall/orderByLineItemResponseMaker";
import orderHeaderDetailResponseMaker from "./OrderAPICall/orderHeaderDetailResponseMaker";
import orderByDeliveryResponseMaker from "./OrderAPICall/orderByDeliveryResponseMaker";
import AuthConfig from "@system/config/auth";
import useCheckAuthPermissions from "src/hooks/component/useCheckAuthPermissions";
import store from "src/storeWire";
import { setPlaceOrderLoading } from "src/store/slice/model/Order";
import Helper from "src/support/Helper";

const [_check_p] = useCheckAuthPermissions();

class OrderAPICall extends Base {
    fetchOrderList = async (params = {}) => {
        let res = {};
        await this.axiosCall(Order.ORDER_LISTING, {
            ...params
        }).then((resHer) => {
            res = resHer.data.data;
        });

        if (res === null) {
            return {}
        } else {
            let result = await new ResponseMaker(res)
            result = await result.process()
            return result.run().get()
        }
    };

    fetchHeaderOrderDetail = async (params = {}) => {
        let res = {};
        await this.axiosCall(Order.HEADER_ORDER_DETAIL, {
            ...params
        }).then((resHer) => {
            res = resHer.data.data;
        });

        let result = await new orderHeaderDetailResponseMaker(res)
        result = await result.process()
        return result.run().get()
    };

    sendEmailOrder = async (params = {}) => {
        let res = {};
        await this.axiosCall(Order.ORDER_EMAIL, {
            ...params
        }, 'post', true).then((resHer) => {
            res = resHer.data.data;
        });

        return res;
    };

    sendOrderPOLineItemEmail = async(params = {}) => {
        let res = {};
        await this.axiosCall(Order.ORDER_PO_LINE_ITEM_EMAIL, {
            ...params
        }, 'post', true).then((resHer) => {
            res = resHer.data;
        }).catch((e) => {
            console.log(e)
        });
        return res;
    }

    fetchOrderListByLineItem = async (params = {}) => {
        let res = {};
        await this.axiosCall(Order.ORDER_BY_LINE_ITEM, {
            ...params
        }).then((resHer) => {
            res = resHer.data.data;
            res['orderNumber'] = params.orderNumber
        });

        if (res === null) {
            return {}
        } else {
            let result = await new orderByLineItemResponseMaker(res)
            result = await result.process()
            return result.run().get()
        }
    };

    fetchOrderListByDelivery = async (params = {}) => {
        let res = {};
        await this.axiosCall(Order.ORDER_BY_DELIVERY, {
            ...params
        }).then((resHer) => {
            res = resHer.data.data;
        });

        if (res === null) {
            return {}
        } else {
            let result = await new orderByDeliveryResponseMaker(res)
            result = await result.process()
            return result.run().get()
        }
    };

    placeYourOrder = async (params = {}) => {
        let res = {};

        let param = { ...params }

        if (!param.emailAddress) {
            param.emailAddress = await AuthConfig.getEmail()
        }

        if ((_check_p('CHECKOUT_PLACE_ORDER_BUTTON').status === true)) {

            if (param.orderPlaced === true) {
                store.dispatch(setPlaceOrderLoading(true))
            }
            console.log('line 118', Order.PLACE_YOUR_ORDER)
            await this.axiosCall(Order.PLACE_YOUR_ORDER, {
                ...param
            }).then((resHer) => {
                if (resHer.data && resHer.data.data) {
                    res = resHer.data.data;
                }
            }).catch((e) => {
            })
        }
        return res
    };

    fetchPlaceOrderItems = async (orderId) => {
        let res = {};

        if ((_check_p('CHECKOUT_PLACE_ORDER_BUTTON').status === true)) {
            let URL = Order.PLACE_ORDER_ITEMS + '?orderId=' + orderId
            await this.axiosCall(URL, {
            }, 'GET').then((resHer) => {
                if (resHer.data.isSuccessFull === true) {
                    res = resHer.data.data;
                }
            }).catch((e) => {
                console.log(e)
            })
        }
        return res
    };

    orderDownloadSingleInvoice = async (params = false) => {
        let res = {};
        let URL = Order.ORDER_DOWNLOAD_SINGLE_INVOICE + '?invoiceNumber=' + params.invoiceNumber
        await this.axiosCall(URL, {}, 'post', false, true).then(async (response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ORDER.pdf');
            document.body.appendChild(link);
            link.click();
        });
        return res;
    };

    exportOrder = async (params = false) => {
        let res = {};
        let API_URL = params.isEmail ? Order.EXPORT_ORDER_ATTACHMENT : Order.EXPORT_ORDER
        await this.axiosCall(API_URL, { ...params }).then(async (response) => {
            if (!params.isEmail) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Order_export.csv');
                document.body.appendChild(link);
                link.click();
            }
        });
        return res;
    };

    getExportOrderCount = async () => {
        let res = 0;
        let URL = Order.ORDER_EXPORT_COUNT
        await this.axiosCall(URL, {}, 'post', false, false).then(async (resHer) => {
            if (resHer.data.isSuccessFull === true) {
                res = Number(resHer.data.data);
            }
        });
        return res;
    }

    placeOrderReturnRequest = async (params) => {
        let res = {};
        const formData = new FormData();
        if (Object.keys(params).length > 0) {
            Object.entries(params).forEach((x, y) => {
                if (x[0] != 'Files') {
                    formData.append(x[0], x[1]);
                }
            });
            params?.Files?.forEach((item, index) => {
                formData.append("Files", item.file)
            });

            await this.axiosCall(Order.ORDER_RETURN_REQUEST, formData, 'post', false, false, 'multipart/form-data').then((resHer) => {
                res = resHer.data;
            }).catch((e) => {
                console.log(e)
            });
        }


        return res;
    }

    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false, contentType = '') => {
        if (data === 'NA') {
            data = {};
        } else {
            if (!contentType) {
                data = await this.mergeDataWithBase(data);
            }
        }
        let config = {
            method: method,
            url: url,
            /* headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json-patch+json'
            }, */
            headers: Helper.getCommonHeader(method, contentType),
            data: data
        };
        // Set Response Type as Blob 
        if (isBlob) {
            config.responseType = 'blob';
        }
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        if (data.ERPPartNumber !== undefined) {
            data.partNumber = data.ERPPartNumber;
        }
        return {
            ...data
        };
    };

    scheduleOrderReport = async (params = false) => {
        let res = false;
        await this.axiosCall(Order.SCHEDULE_ORDER_REPORT, params, 'post').then(async (response) => {
            res = response;
        }).catch((e) => {
            res = e?.response;
        });
        return res;
    }

    getOrderReports = async (params = false) => {
        let res = false;
        await this.axiosCall(Order.GET_ORDER_REPORTS, {}, 'get').then(async (response) => {
            res = response;
        }).catch((e) => {
            res = e?.response;
        });
        return res;
    }

    deleteOrderReport = async (reportId = false) => {
        let res = false;
        await this.axiosCall(`${Order.DELETE_ORDER_REPORTS}/${reportId}`, {}, 'delete').then(async (response) => {
            res = response;
        }).catch((e) => {
            res = e?.response;
        });
        return res;
    }

    fetchManufacturerList = async () => {

        let res = {};
        await this.axiosCall(Order.ORDER_MANUFACTURE_LIST, {}, 'get').then((resHer) => {
            res = resHer.data.data.payload.manufacturerDataList;
        });

        return res;
    };

    fetchOrderReturnReasonsList = async () => {
        let res = {};
        await this.axiosCall(Order.ORDER_REASON_RETURN_LIST, {}, 'get').then((resHer) => {
            res = resHer?.data?.data;
        });

        return res;
    }
}

export default OrderAPICall;